import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import $, { post } from "jquery";
import { urlparams } from "../../config/bootstrap";
import HomeIcon from "../common/HomeIcon";
import Carousel from "../carousel/carousel";
import NativeShare from "../common/NativeShare";

export default class DetailPage extends Component {
  constructor() {
    super();
    this.state = {
      data: null,
      image: null,
    };
  }

  componentDidMount() {
    let postId = this.props.match.params.postId;

    let ref = this;

    if (postId.indexOf("m") != -1) {
      $.get("/mantra.json", function (data) {
        let student =
          window.location.hostname.indexOf("localhost") != -1
            ? data["student"]
            : JSON.parse(data).student;
        let parent =
          window.location.hostname.indexOf("localhost") != -1
            ? data["parent"]
            : JSON.parse(data).parent;
        let all = { ...student, ...parent };

        // console.log(all[postId]);
        ref.setState({
          shoeHomePage: true,
          image: all[postId]["template_url"],
        });
      });
    } else {
      $.ajax({
        url: "https://ew.narendramodi.in/api",
        type: "POST",
        data: {
          action: "getdetail",
          id: postId,
          token: "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga",
        },
        success: function (data) {
          if (data._resultflag === "1") {
            ref.setState({
              data: data.metaresult,
              image: data.imageurl,
              shoeHomePage: true,
            });
          } else {
            ref.setState({
              data: null,
              image: null,
              shoeHomePage: true,
            });
          }
        },
        error: function (error) {
          console.log(error);
          ref.setState({
            data: null,
            image: null,
            shoeHomePage: true,
          });
        },
      });
    }
  }

  render() {
    const { data, image, shoeHomePage } = this.state;

    return (
      <div>
        {/* {data && (
          <>
            <Carousel data={data} hideNavigation={true} />
            <HomeIcon />
          </>
        )} */}

        <div className="">
          <div className="">
            <div className="">
              {image && <img src={image} className="img-fluid" alt="" />}
            </div>
          </div>
          <div className="">
            <ul>
              <li>
                <div className="preview_btn">
                  {shoeHomePage && (
                    <NavLink to={"/" + urlparams}>Home page</NavLink>
                  )}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
